import axios from "axios";
import { config } from "./config";
import { ResponseStatusEnum } from "@/enums/httpEnum";

const axiosInstance = axios.create(config)


axiosInstance.interceptors.request.use(config => {
  return config
}, error => {
  console.error("request error:", error)
})

axiosInstance.interceptors.response.use((response) => {
  console.log('API Response:', response);
  if(response.data.code === ResponseStatusEnum.SUCCESS){
    return response
  }
  return response
}, (error) => {
  console.error("API Request Error:", error)
  if (error.response) {
    console.error("Status:", error.response.status);
    console.error("Data:", error.response.data);
    console.error("Headers:", error.response.headers);
  } else if (error.request) {
    console.error("No response received:", error.request);
  } else {
    console.error("Request error:", error.message);
  }
  // Make sure to reject the promise so error handlers can catch it
  return Promise.reject(error)
})

export {axiosInstance}